import Head from "next/head";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { tokens } from "src/locales/tokens";

export const Seo = (props) => {
  const { title } = props;
  const { t } = useTranslation();

  const fullTitle = title
    ? title +
      " | " +
      t(tokens.label.clientNameShort) +
      " - " +
      t(tokens.label.systemShortName)
    : t(tokens.label.clientNameShort) + " - " + t(tokens.label.systemShortName);

  return (
    <Head>
      <title>{fullTitle}</title>
    </Head>
  );
};

Seo.propTypes = {
  title: PropTypes.string,
};
